import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';

export function BillingPage() {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Facturación</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">Próximamente. Suscripciones y planes.</p>
        </CardContent>
      </Card>
    </div>
  );
}
